// Passenger Wallet types — mirrors driverWallet.ts

export interface IUpdatePassengerWalletBalance {
  balance: string;
}

export interface IPassengerWallet {
  id: string;
  passenger_id: string;
  balance: number;
  passenger: {
    first_name: string;
    last_name: string;
    phone: string;
    image?: string;
    is_active: boolean;
  };
  created_at: string;
  updated_at: string;
}

export interface IPassengerWalletHistory {
  id: string;
  wallet_id: string;
  amount: number;
  trip_id: string | null;
  admin_id: string | null;
  type: "top_up" | "deduct" | "reward" | "referral";
  reason: string;
  trip?: {
    id: string;
    pickup_address: string;
    drop_off_address: string;
    distance: number;
    price: number;
  } | null;
  admin?: {
    first_name: string;
    last_name: string;
  } | null;
  created_at: string;
  updated_at: string;
}

export interface IPassengerWalletDetail extends IPassengerWallet {
  histories: IPassengerWalletHistory[];
}

export interface IPassengerWalletDetailResponse {
  per_page: number;
  loading: boolean;
  page: number;
  total: number;
  data: IPassengerWalletDetail;
}

export const defaultPassengerWalletDetail: IPassengerWalletDetailResponse = {
  loading: true,
  data: {} as any,
  page: 1,
  per_page: 10,
  total: 0,
};
